module.exports = __webpack_public_path__ + "static/media/Client3.011516b3.png";